import { useMenuContext, useAdvertContactsVisibleControl } from '@edikk-edikk/ui';
import { useCallback } from 'react';
import { UseControlsResultType } from '#baseMenu/components/controls/middle-button/advert-contacts/hooks';

const useControls = (): UseControlsResultType => {
  const { hide: hideMenu, isOpen: isMenuOpen } = useMenuContext();
  const {
    isOpen: isOpenAdvertContacts,
    open: openAdvertContacts,
    hide: hideAdvertContacts,
  } = useAdvertContactsVisibleControl();

  const handlerClick = useCallback(() => {
    if (isMenuOpen) {
      hideMenu();
    }

    if (isOpenAdvertContacts) {
      hideAdvertContacts();
    } else {
      openAdvertContacts();
    }
  }, [hideAdvertContacts, hideMenu, isMenuOpen, isOpenAdvertContacts, openAdvertContacts]);

  return {
    isOpen: isOpenAdvertContacts,
    handlerClick,
  };
};

export { useControls };
